import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import styles from "./styles.module.scss";
import CheckBox from "app/components/inputs/CheckBox";

export type TimeTable = { id: number; name: string };

interface TimeTableSelectorProps {
  timeTables: TimeTable[];
  value: number[];
  onChange: (timeTableIds: number[]) => void;
}

export default function TimeTableSelector(props: TimeTableSelectorProps) {
  const { timeTables, value, onChange } = props;

  const { t } = useTranslation();
  // Folded, like every other card in the modal. It used to open itself
  // whenever a schedule was ticked -- which is the default state of a new
  // booking option, so the modal opened with this one card already unfolded
  // (CFTB-3523).
  const [showAvailability, setShowAvailability] = useState(false);

  const handleAvailabilityChange = (checked: boolean, timeTable: TimeTable) => {
    let ids = [...value];
    if (checked) {
      ids.push(timeTable.id);
    } else {
      ids = ids.filter(id => id !== timeTable.id);
    }
   onChange(ids);
  };

  return (
    <div className={styles.time_table_selection}>
      <div className={styles.header} onClick={() => setShowAvailability(!showAvailability)}>
        <div className={styles.title}>{t("Custom availability")}</div>
        <i className={`ico ico-chevron ${showAvailability ? styles.open : ''}`} />
      </div>
      <div style={{ display: showAvailability ? '' : 'none' }}>
        <p className={styles.info}>{t("Uncheck schedules when this booking option should NOT be available.")}</p>
        <p>{t("Schedules")}</p>
        <ul className={styles.time_tables_list}>
          {timeTables.map(timeTable => {
            return (
              <li key={timeTable.id}>
                <CheckBox
                  className={styles.time_table_option}
                  key={timeTable.id}
                  name={`time-table-${timeTable.id}`}
                  label={timeTable.name}
                  checked={value.includes(timeTable.id)}
                  onChange={(checked) => handleAvailabilityChange(checked, timeTable)}
                  squareCheckIcons
                />
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
